import getListViewState from './getListViewState';
import type CopilotResultsStatus from '../store/schema/CopilotResultsStatus';

export function isCopilotResultsTabVisible(): boolean {
    return !!getListViewState().copilotResultsTableViewId;
}

export function getCopilotResultsTableViewId(): string | undefined {
    return getListViewState().copilotResultsTableViewId;
}

export function getCopilotResultsOriginTableViewId(): string | undefined {
    return getListViewState().copilotResultsOriginTableViewId;
}

export function getCopilotResultsStatus(): CopilotResultsStatus {
    return getListViewState().copilotResultsStatus;
}
